import React from 'react'
import Home from './Pages/Home/Home';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import BMICalc from './Pages/BMICalculator/BMICalc'
import Calculator from './Pages/Calculator/Calculator';
import Stopwatch from './Pages/StopWatch/Stopwatch';
import Obessed from './Pages/BMICalculator/Obessed';
import OverWeight from './Pages/BMICalculator/OverWeight';
import Healthy from './Pages/BMICalculator/Healthy';
import UnderWeight from './Pages/BMICalculator/UnderWeight';
import ExUnderWeight from './Pages/BMICalculator/ExUnderWeight';
import EmojiSearch from './Pages/EmojiSearch/EmojiSearch';
import Quiz from './Pages/Quiz/Quiz';
import DailyNeeds from './Pages/DailyNeeds/DailyNeeds';
import Shopping from './Pages/Shopping/Shopping'
import Foods from './Pages/Shopping/Foods'
import Items from './Pages/Shopping/Items'
import Plants from './Pages/Shopping/Plants'
import Cart from './Pages/Shopping/Cart'
import Payment from './Pages/Shopping/Payment';


const App = () => {

  return (
    <>
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<Home/>} />
      <Route path='/calc' element={<Calculator/>} />
      <Route path='/bmi' element={<BMICalc/>} />
      <Route path='/stopwatch' element={<Stopwatch/>} />
      <Route path='/underweight' element={<UnderWeight/>} />
      <Route path='/exunhealthy' element={<ExUnderWeight/>} />
      <Route path='/healthy' element={<Healthy/>} />
      <Route path='/overweight' element={<OverWeight/>} />
      <Route path='/obessed' element={<Obessed/>} />
      <Route path='/emoji' element={<EmojiSearch/>} />
      <Route path='/quiz' element={<Quiz/>} />
      <Route path='/daily' element={<DailyNeeds/>} />
      <Route path='/shopping' element={<Shopping/>} />
      <Route path='/food' element={<Foods/>} />
      <Route path='/items' element={<Items />} />
      <Route path='/plants' element={<Plants/>} />
      <Route path='/cart' element={<Cart/>} />
      <Route path='/payment' element={<Payment/>} />
    </Routes>
    </BrowserRouter>
    </>
  )
}

export default App;